// initial state
const state = {
    show: false,
    key: null,
    value: null,
    position: null, // {top, left}
    props: {}, // Props to be directly bound on the datepicker component
};

// getters
const getters = {
    showModal: (state) => state.show,
    getKey: (state) => state.key,
    getValue: (state) => state.value,
    getPosition: (state) => state.position,
    getProps: (state) => state.props,
};

// actions
const actions = {
    open({ commit }, { key, value, position, props }) {
        // Open modal
        commit('setKey', key);
        commit('setValue', value);
        commit('setPosition', position);
        commit('setProps', props);
        commit('setShowModal', true);
    },
    close({ commit }) {
        // Close modal
        commit('setKey', null);
        commit('setValue', null);
        commit('setPosition', null);
        commit('setProps', null);
        commit('setShowModal', false);
    },
};

// mutations
const mutations = {
    setShowModal(state, show) {
        state.show = show;
    },
    setKey(state, key) {
        state.key = key;
    },
    setValue(state, value) {
        state.value = value;
    },
    setPosition(state, position) {
        state.position = position;
    },
    setProps(state, props) {
        state.props = props;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
